// .MuiButton-root {
//     color: white;
//     box-shadow: none;
//     background-color: $dark-primary;

import { Button, styled } from '@mui/material';

//     &:hover {
//         background-color: $primary;
//     }

//     &.MuiButton-containedSecondary {
//         background-color: $dark-secondary;

//         &:hover {
//             background-color: $secondary;
//         }
//     }

//     &.Mui-disabled {
//         background-color: $gray;
//     }
// }

export default styled(Button)({
    textTransform: 'none',
    fontSize: '1rem',
});
